module.exports = __webpack_public_path__ + "static/media/06.0fb6d0d4.png";